const colors = {
  applied: ['#ff7d0c', '#ffba3c', '#ffee7c'],
  admitted: ['#2e855a', '#50c08e', '#71ffc7'],
  deposited: ['#00496a', '#009fbf', '#00ffff'],
  housing: ['#bb0038', '#e37685', '#ffc9d2'],
  orientation: ['#58508d', '#5d64c4', '#4c7bff'],
  cumulative: ['#000', '#333', '#666'],
  percentage: ['#000', '#333', '#666'],
  default: ['#B81414', '#DA8035', '#0C6F6F', '#109310'],
}

export default colors
